import { sample, range } from 'lodash';

export default {
    data() {
        return {
            prevExtractionNumber: null,
            prevExponentiationNumber: null,
        };
    },
    computed: {
        extraOperationEnabled() {
            const onlyTwoDigitDifficulty =
                this.parameters.difficulties.length === 1 && this.parameters.difficulties[0] === 2;
            const extraOperationChosen =
                this.parameters.extraOperations &&
                Object.values(this.parameters.extraOperations).find(value => value === true);

            return onlyTwoDigitDifficulty && extraOperationChosen;
        },
        extraOperationLastDigit() {
            return (
                (this.parameters.extraOperations.endsWithFiveSquare && 5) ||
                (this.parameters.extraOperations.endsWithOneSquare && 1) ||
                (this.parameters.extraOperations.endsWithNineSquare && 9)
            );
        },
        currentDigitCapacity() {
            let counter = this.parameters.dictation ? this.examplesPlayed : this.answers.good;
            if (counter >= this.parameters.difficulties.length) {
                let key = Math.floor(counter / this.parameters.difficulties.length);
                key = counter - this.parameters.difficulties.length * key;
                return this.parameters.difficulties[key];
            }
            return this.parameters.difficulties[counter];
        },
    },
    methods: {
        getDigitCapacity() {
            return this.parameters.fractions
                ? { mainPart: this.currentDigitCapacity, fractionalPart: this.parameters.fractionalPart }
                : { mainPart: this.currentDigitCapacity };
        },
        generateExample() {
            let operations = [];
            for (let key in this.parameters.operations) {
                this.parameters.operations[key] && operations.push(key);
            }
            operations[Math.floor(Math.random() * operations.length)] === 'exponentiation'
                ? this.generateExponentiation()
                : this.generateRootExtraction();
        },
        generateExponentiation() {
            let number;
            let prevExample = this.prevExponentiationNumber;
            let digitCapacity = this.getDigitCapacity();
            do {
                number = this.generateNumber(digitCapacity);
            } while (number === prevExample);
            this.prevExponentiationNumber = number;
            this.example = { number, operation: 'square' };
        },
        generateRootExtraction() {
            let number;
            let prevExample = this.prevExtractionNumber;
            do {
                number = this.generateNumberForRootExtraction();
            } while (number === prevExample);
            this.prevExtractionNumber = number;
            this.example = { number, operation: 'root' };
        },
        generateBoundaries(power) {
            return { leftBoundary: Math.pow(10, power - 1), rightBoundary: Math.pow(10, power) };
        },
        generateNumberForRootExtraction() {
            let digitCapacity = this.getDigitCapacity();
            let { leftBoundary, rightBoundary } = this.generateBoundaries(
                digitCapacity.mainPart + +(digitCapacity.fractionalPart ?? 0)
            );
            leftBoundary = Math.ceil(Math.sqrt(leftBoundary));
            rightBoundary = Math.sqrt(rightBoundary);
            let answer = this.generateNumberBetweenBoundaries({ leftBoundary, rightBoundary });
            if (digitCapacity.fractionalPart) {
                let example = answer ** 2;
                example /= Math.pow(10, digitCapacity.fractionalPart);
                return example;
            }
            return Math.pow(answer, 2);
        },
        generateNumber(digitCapacity) {
            let result = this.generateNumberOfGivenLength(digitCapacity.mainPart);
            if (digitCapacity.fractionalPart) {
                let fractionalNumber = this.generateNumberOfGivenLength(digitCapacity.fractionalPart);
                result += fractionalNumber / Math.pow(10, digitCapacity.fractionalPart);
            }
            return result;
        },
        generateNumberOfGivenLength(length) {
            let { leftBoundary, rightBoundary } = this.generateBoundaries(length);
            return this.generateNumberBetweenBoundaries({ leftBoundary, rightBoundary });
        },
        generateNumberBetweenBoundaries({ leftBoundary, rightBoundary }) {
            if (!this.extraOperationEnabled) {
                return Math.floor(leftBoundary + Math.random() * (rightBoundary - leftBoundary));
            }

            let numbersThatSatisfyExtraOperation = range(leftBoundary, rightBoundary).filter(number => {
                return number % 10 === this.extraOperationLastDigit;
            });

            return sample(numbersThatSatisfyExtraOperation);
        },
    },
};
